import { render } from "./DialogAd.vue?vue&type=template&id=71bc0459&scoped=true"
import script from "./DialogAd.vue?vue&type=script&lang=js"
export * from "./DialogAd.vue?vue&type=script&lang=js"

import "./DialogAd.vue?vue&type=style&index=0&id=71bc0459&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71bc0459"]])

export default __exports__